const postAddDocumentServices = {
  toastr: 'Documento agregado',
  toastr1:'El documento fue agregado con éxito.'
};

export default postAddDocumentServices;
